// @flow

// Libs
import { createSelector } from 'reselect'
import _find from 'lodash/find'

// Utils
import traverse from 'fc-utils/traverse'

// Selectors
import { farms$ } from 'fc-assets'

// Types
import type { AssetsById } from 'fc-model-assets/types'

// Constants
import { PROP_ASSET_ID } from 'fc-model-assets'

// Local Selectors
export const selectedFarmIdNotValidated$ = traverse(['mapModule', 'selectedFarmId'])

// Exports
export default createSelector([farms$, selectedFarmIdNotValidated$], (farms: AssetsById, farmId: number): ?number => {
  const isValidFarmId = _find(farms, { [PROP_ASSET_ID]: farmId })

  return isValidFarmId ? farmId : null
})
